import { Link } from "react-router-dom";
import { media } from "@/config/site";
import { getServiceBySlug } from "@/config/services";
import { waMessages } from "@/lib/whatsapp";
import MediaImage from "@/components/feature/MediaImage";
import WhatsAppLink from "@/components/feature/WhatsAppLink";
import Reveal from "@/components/feature/Reveal";

const bridalLinks = [
  {
    slug: "gelin-saci-zarif-topuz",
    label: "Zarif Topuz",
  },
  {
    slug: "gelin-saci-hacimli-topuz",
    label: "Hacimli Topuz",
  },
  {
    slug: "ozel-gun-makyaji-turban",
    label: "Makyaj & Türban",
  },
];

export default function Bridal() {
  return (
    <section id="gelin" className="scroll-mt-24 bg-background-300">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:items-center">
          <Reveal className="lg:col-span-5">
            <p className="text-xs uppercase tracking-[0.28em] text-accent-600 md:text-sm">
              Gelin & Özel Gün
            </p>
            <h2 className="mt-4 font-heading text-3xl leading-tight text-primary-800 md:text-5xl">
              En özel gününüze, size özel hazırlık.
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-foreground-700">
              Zarif topuz, hacimli topuz ve makyaj & türban çalışmalarımızla, hayal ettiğiniz gelin
              görünümünü birlikte planlıyoruz. Detaylar için ilgili hizmet sayfasına göz atabilir
              ya da doğrudan bize yazabilirsiniz.
            </p>

            <ul className="mt-8 space-y-3">
              {bridalLinks.map((link) => {
                const service = getServiceBySlug(link.slug);
                return (
                  <li key={link.slug}>
                    <Link
                      to={`/hizmetler/${link.slug}`}
                      className="group inline-flex items-center gap-3 text-base font-medium text-primary-800 transition-colors hover:text-accent-600"
                    >
                      <span className="flex h-8 w-8 items-center justify-center rounded-full border border-accent-500 text-accent-600 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
                        <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
                      </span>
                      {service ? service.name : link.label}
                    </Link>
                  </li>
                );
              })}
            </ul>

            <WhatsAppLink
              message={waMessages.bridal}
              label="Gelin Hazırlığını Konuşalım"
              variant="primary"
              size="md"
              sourceSection="bridal"
              className="mt-8"
            />
          </Reveal>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-3 gap-4 md:gap-6">
              {media.bridal.map((src, i) => (
                <Reveal key={i} delay={i * 100}>
                  <div
                    className={`overflow-hidden rounded-lg bg-background-200 ${
                      i === 1 ? "mt-8" : ""
                    }`}
                  >
                    <div className="aspect-[3/4] w-full">
                      <MediaImage
                        src={src}
                        alt={
                          i === 0
                            ? "Duvak ve aksesuarla zarif gelin topuzu çalışması"
                            : i === 1
                              ? "Işıltılı hacimli gelin topuzu çalışması"
                              : "Helezon özel gün topuzu çalışması"
                        }
                        className="h-full w-full"
                      />
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}